import { console } from 'react-redux-app/lib/modules/core/utils';

import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionLoadBalanceSummaryRequest } from '../../actions/loadBalanceSummary';

import { getLoadBalanceSummaryError } from '../../selectors';


export default ({ getState, dispatch }) => (
  function loadBalanceSummaryHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadBalanceSummaryRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadBalanceSummaryError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadBalanceSummaryHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
